import React from 'react';

export default function ApprovalMatrix() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Approval Matrix</h1>
      <p className="text-gray-500">Halaman Approval Matrix</p>
    </div>
  );
}
